import {
  Home,
  Box,
  DollarSign,
  UserPlus,
  Users,
  Chrome,
  Settings,
  Airplay,
  FolderPlus,
  File,
  Command,
  Cloud,
  Book,
  FileText,
  Server,
  Image,
  Sliders,
  Map,
  GitPullRequest,
  Calendar,
  Edit,
  Mail,
  MessageSquare,
  UserCheck,
  Layers,
  HelpCircle,
  Database,
  Headphones,
  Mic,
  ShoppingBag,
  Search,
  AlertOctagon,
  Lock,
  Briefcase,
  BarChart,
  Target,
  List,
  Package
} from "react-feather";

export const MENUITEMS = [
  // Dashboard***********************************
  {
    title: "Dashboard",
    icon: Home,
    type: "link",
    path: "/dashboard/default",
    active: false
  },
  {
    title: "Masters",
    icon: Airplay,
    type: "sub",
    active: false,
    children: [
      {
        path: "/masters/country/list",
        title: "Country",
        type: "link",
        permission: "country.list"
      },
      {
        path: "/masters/state/list",
        title: "State",
        type: "link",
        permission: "state.list"
      },
      {
        path: "/masters/city/list",
        title: "City",
        type: "link",
        permission: "city.list"
      },
      {
        path: "/masters/area/list",
        title: "Area",
        type: "link",
        permission: "area.list"
      },
      {
        path: "/masters/department/list",
        title: "Department",
        type: "link",
        permission: "department.list"
      },
      {
        path: "/masters/consultant-specialization/list",
        title: "Consultant Specialization",
        type: "link",
        permission: "consultantspecialization.list"
      },
      {
        path: "/masters/consultant/list",
        title: "Consultant",
        type: "link",
        permission: "consultant.list"
      },
      {
        path: "/masters/staff/list",
        title: "Staff",
        type: "link",
        permission: "staff.list"
      },
      {
        path: "/masters/case/list",
        title: "Case",
        type: "link",
        permission: "case.list"
      },
      {
        path: "/masters/billing-charges-group/list",
        title: "Billing Charges Group",
        type: "link",
        permission: "billingchargesgroup.list"
      },
      {
        path: "/masters/billing-charges/list",
        title: "Billing Charges",
        type: "link",
        permission: "billingcharges.list"
      },
      {
        path: "/masters/group-account/list",
        title: "Group Account",
        type: "link",
        permission: "groupaccount.list"
      },
      {
        path: "/masters/ledger-account/list",
        title: "Ledger Account",
        type: "link",
        permission: "ledgeraccount.list"
      }
    ]
  },
  {
    title: "OPD",
    type: "sub",
    icon: Airplay,
    active: false,
    children: [
      {
        title: "Transaction",
        type: "sub",
        children: [
          {
            title: "Registration / OPD Entry",
            type: "link",
            path: "/opd/transaction/opd-entry/list",
            permission: "opdregistration.list"
          },
          {
            title: "OPD Charges Entry",
            type: "link",
            path: "/opd/transaction/opd-charges-entry/list",
            permission: "opdcharges.list"
          },
          {
            title: "Refund Entry",
            type: "link",
            path: "/opd/transaction/opd-refund-entry/list",
            permission: "opdrefund.list"
          },
          {
            title: "OPD Prescription Entry",
            type: "link",
            path: "/opd/transaction/opd-prescription-entry/list",
            permission: "opdprescription.list"
          },
          {
            title: "patient Search",
            type: "link",
            path: "/opd/transaction/patient-search/list",
            permission: "patientsearch.list"
          },
          {
            title: "Medical Certificate Entry",
            type: "link",
            path: "/opd/transaction/medical-certificate-entry/list",
            permission: "medicalcertificate.list"
          }
        ]
      },
      {
        title: "Report",
        type: "sub",
        children: [
          {
            title: "OPD Registration Report",
            type: "link",
            path: "/opd/reports/opd-registration-report",
            permission: "opdregistrationreport"
          },
          {
            title: "Area Wise OPD Registration Report",
            type: "link",
            path: "/opd/reports/area-wise-opd-registration-report",
            permission: "areawiseopdregistrationreport"
          },
          {
            title: "Department Wise OPD Registration Report",
            type: "link",
            path: "/opd/reports/department-wise-opd-registration-report",
            permission: "departmentwiseopdregistrationreport"
          },
          {
            title: "Case Wise OPD Registration Report",
            type: "link",
            path: "/opd/reports/case-wise-opd-registration-report",
            permission: "casewiseopdregistrationreport"
          },
          {
            title: "Consultant Wise OPD Registration Report",
            type: "link",
            path: "/opd/reports/consultant-wise-opd-registration-report",
            permission: "consultantwiseopdregistrationreport"
          },
          {
            title: "Gender Wise OPD Registration Report",
            type: "link",
            path: "/opd/reports/gender-wise-opd-registration-report",
            permission: "genderwiseopdregistrationreport"
          },
          {
            title: "OPD Charges Report",
            type: "link",
            path: "/opd/reports/opd-charges-report",
            permission: "opdchargesreport"
          },
          {
            title: "Group Wise Charges Report",
            type: "link",
            path: "/opd/reports/group-wise-charges-report",
            permission: "groupwisechargesreport"
          },
          {
            title: "Emergency Statistics Report",
            type: "link",
            path: "/opd/reports/emergency-statistics-report",
            permission: "emergencystatisticsreport"
          },
          {
            title: "OPD Summary Report",
            type: "link",
            path: "/opd/reports/opd-summary-report",
            permission: "opdsummaryreport"
          },
          {
            title: "OPD Refund Report",
            type: "link",
            path: "/opd/reports/opd-refund-report",
            permission: "opdrefundreport"
          },
          {
            title: "Estimate for Treatment Report",
            type: "link",
            path: "/opd/reports/estimate-for-treatment-report",
            permission: "estimatefortreatmentreport"
          }
        ]
      }
    ]
  },
  {
    title: "IPD ",
    type: "sub",
    icon: Airplay,
    active: false,
    children: [
      {
        title: "Master",
        type: "sub",
        children: [
          {
            title: "Room Category",
            type: "link",
            path: "/ipd/master/room-category/list",
            permission: "roomcategory.list"
          },
          {
            title: "Nursing Station",
            type: "link",
            path: "/ipd/master/nursing-station/list",
            permission: "nursingstation.list"
          },
          {
            title: "Room",
            type: "link",
            path: "/ipd/master/room/list",
            permission: "room.list"
          }
        ]
      },
      {
        title: "Transaction",
        type: "sub",
        children: [
          {
            title: "IPD Registration Entry",
            type: "link",
            path: "/ipd/transaction/ipd-entry/list",
            permission: "ipdregistration.list"
          },
          {
            title: "Payment Receive Entry",
            type: "link",
            path: "/ipd/transaction/payment-receive-entry/list",
            permission: "paymentreceive.list"
          },
          {
            title: "Room Change Entry",
            type: "link",
            path: "/ipd/transaction/room-change-entry/list",
            permission: "roomchange.list"
          },
          {
            title: "Bill Charges Entry",
            type: "link",
            path: "/ipd/transaction/ipd-bill-charges-entry/list",
            permission: "ipdbillcharges.list"
          },
          {
            title: "Delivery Entry",
            type: "link",
            path: "/ipd/transaction/delivery-entry/list",
            permission: "delivery.list"
          },
          {
            title: "Patients History Entry",
            type: "link",
            path: "/ipd/transaction/patient-history-entry/list",
            permission: "patienthistory.list"
          },
          {
            title: "IPD Refund Entry",
            type: "link",
            path: "/ipd/transaction/ipd-refund-entry/list",
            permission: "ipdrefund.list"
          },
          {
            title: "Patient Discharge Entry",
            type: "link",
            path: "/ipd/transaction/patient-discharge-entry/list",
            permission: "patientdischarge.list"
          },
          {
            title: "Discharge Card Entry",
            type: "link",
            path: "/ipd/transaction/discharge-card-entry/list",
            permission: "dischargecard.list"
          },
          {
            title: "Medical Certificate Entry",
            type: "link",
            path: "/ipd/transaction/ipd-medical-certificate-entry/list",
            permission: "ipdmedicalcertificate.list"
          },
          {
            title: "MlC Entry",
            type: "link",
            path: "/ipd/transaction/mlc-entry/list",
            permission: "mlc.list"
          },
          {
            title: "Oxygen Given Entry",
            type: "link",
            path: "/ipd/transaction/oxygen-given-entry/list",
            permission: "oxygengiven.list"
          },
          {
            title: "Death Certificate Entry",
            type: "link",
            path: "/ipd/transaction/death-certificate-entry/list",
            permission: "deathcertificate.list"
          },
          {
            title: "IPD Consultant Change",
            type: "link",
            path: "/ipd/transaction/ipd-consultant-change/list",
            permission: "ipdconsultantchange.list"
          }
        ]
      },
      {
        title: "Reports",
        type: "sub",
        children: [
          {
            title: "IPD Registration Report",
            type: "link",
            path: "/ipd/reports/ipd-registration-report",
            permission: "ipdregistrationreport"
          },
          {
            title: "Birth Report",
            type: "link",
            path: "/ipd/reports/birth-report",
            permission: "birthreport"
          },
          {
            title: "MTP Register",
            type: "link",
            path: "/ipd/reports/mtp-report",
            permission: "mtpreport"
          },
          {
            title: "Room Change Report",
            type: "link",
            path: "/ipd/reports/room-change-report",
            permission: "roomchangereport"
          },
          {
            title: "Discharge Report",
            type: "link",
            path: "/ipd/reports/discharge-report",
            permission: "dischargereport"
          },
          {
            title: "Discharge Patient Status Report",
            type: "link",
            path: "/ipd/reports/discharge-patient-status-report",
            permission: "dischargepatientstatusreport"
          },
          {
            title: "Discharge Patient Dues Report",
            type: "link",
            path: "/ipd/reports/discharge-patient-dues-report",
            permission: "dischargepatientduesreport"
          },
          {
            title: "Doctor wise Patient Status Report",
            type: "link",
            path: "/ipd/reports/doctor-wise-patient-status-report",
            permission: "doctorwisepatientstatusreport"
          },
          {
            title: "In Patient Report",
            type: "link",
            path: "/ipd/reports/in-patient-report",
            permission: "inpatientreport"
          },
          {
            title: "Department Census Report",
            type: "link",
            path: "/ipd/reports/department-census-report",
            permission: "departmentcensusreport"
          },
          {
            title: "Discharge Bill Report",
            type: "link",
            path: "/ipd/reports/discharge-bill-report",
            permission: "dischargebillreport"
          },
          {
            title: "Discount Report",
            type: "link",
            path: "/ipd/reports/discount-report",
            permission: "discountreport"
          },
          {
            title: "IPD Charges Report",
            type: "link",
            path: "/ipd/reports/ipd-charges-report",
            permission: "ipdchargesreport"
          },
          {
            title: "Group Wise Charge IPD Report",
            type: "link",
            path: "/ipd/reports/ipd-group-wise-charges-report",
            permission: "ipdgroupwisechargesreport"
          },
          {
            title: "IPD Patient Consultant Wise Report",
            type: "link",
            path: "/ipd/reports/ipd-patient-consultant-wise-report",
            permission: "ipdpatientconsultantwisereport"
          },
          {
            title: "IPD Patient Receipts Report",
            type: "link",
            path: "/ipd/reports/ipd-patient-receipts-report",
            permission: "ipdpatientreceiptsreport"
          },
          {
            title: "MLC Report",
            type: "link",
            path: "/ipd/reports/mlc-report",
            permission: "mlcreport"
          },
          {
            title: "IPD Refund Report",
            type: "link",
            path: "/ipd/reports/discount-report",
            permission: "ipdrefundreport"
          },
          {
            title: "Room Category Wise Report",
            type: "link",
            path: "/ipd/reports/room-category-wise-report",
            permission: "roomcategorywisereport"
          },
          {
            title: "IPD Gender Wise Report",
            type: "link",
            path: "/ipd/reports/ipd-gender-wise-report",
            permission: "ipdgenderwisereport"
          }
        ]
      },
      {
        title: "O. T. Management",
        type: "sub",
        children: [
          {
            title: "Operation Booking Entry",
            type: "link",
            path: "/ipd/otmanagement/operation-booking-entry/list",
            permission: "operationbooking.list"
          },
          {
            title: "Operation Notes Entry",
            type: "link",
            path: "/ipd/otmanagement/operation-notes-entry/list",
            permission: "operationnotes.list"
          },
          {
            title: "Operation Booking Report",
            type: "link",
            path: "/ipd/otmanagement/operation-booking-report",
            permission: "operationbookingreport"
          },
          {
            title: "Operation Report",
            type: "link",
            path: "/ipd/otmanagement/operation-report",
            permission: "operationreport"
          }
        ]
      },
      {
        title: "Help Desk",
        type: "sub",
        children: [
          {
            title: "Patient Status",
            type: "link",
            path: "/ipd/helpdesk/patient-status",
            permission: "patientstatus"
          },
          {
            title: "IPD Enquiry",
            type: "link",
            path: "/ipd/helpdesk/ipd-enquiry",
            permission: "ipdenquiry"
          },
          {
            title: "Patient Search",
            type: "link",
            path: "/ipd/helpdesk/patient-search",
            permission: "patientsearch"
          }
        ]
      }
    ]
  },
  {
    title: "Diagnosis",
    type: "sub",
    icon: Airplay,
    active: false,
    children: [
      {
        title: "Master",
        type: "sub",
        children: [
          {
            title: "Departmental Sub Speciality Master",
            type: "link",
            path: "/diagnosis/master/departmental-sub-speciality/list",
            permission: "departmentalsubspeciality.list"
          },
          {
            title: "Category Master (investigation)",
            type: "link",
            path: "/diagnosis/master/investigation-category/list",
            permission: "investigationcategory.list"
          },
          {
            title: "Pathology Test Master",
            type: "link",
            path: "/diagnosis/master/pathology-test/list",
            permission: "pathologytest.list"
          },
          {
            title: "Radiology Test Master",
            type: "link",
            path: "/diagnosis/master/radiology-test/list",
            permission: "radiologytest.list"
          },
          {
            title: "Panel Master",
            type: "link",
            path: "/diagnosis/master/panel/list",
            permission: "panel.list"
          },
          {
            title: "Sub Speciality Seperate Test Rates",
            type: "link",
            path: "/diagnosis/master/sub-speciality-seperate-test-rates/list",
            permission: "subspecialityseperatetestrates.list"
          }
        ]
      },
      {
        title: "Transaction",
        type: "sub",
        children: [
          {
            title: "Lab Registration Entry",
            type: "link",
            path: "/diagnosis/transaction/lab-registration-entry/list",
            permission: "labregistration.list"
          },
          {
            title: "Pathology Test Value Entry",
            type: "link",
            path: "/diagnosis/transaction/pathology-test-value-entry/list",
            permission: "pathologytestvalue.list"
          },
          {
            title: "Radiology Test Value Entry",
            type: "link",
            path: "/diagnosis/transaction/radiology-test-value-entry/list",
            permission: "radiologytestvalue.list"
          },
          {
            title: "Payment Receive Entry",
            type: "link",
            path: "/diagnosis/transaction/payment-receive-entry/list",
            permission: "paymentreceive.list"
          },
          {
            title: "Pathology Status",
            type: "link",
            path: "/diagnosis/transaction/pathology-status/list",
            permission: "pathologystatus.list"
          },
          {
            title: "Lab Refund Entry",
            type: "link",
            path: "/diagnosis/transaction/lab-refund-entry/list",
            permission: "labrefund.list"
          },
          {
            title: "Lab Registration Multiple",
            type: "link",
            path: "/diagnosis/transaction/lab-registration-multiple/list",
            permission: "labregistrationmultiple.list"
          },
          {
            title: "Form-F Entry",
            type: "link",
            path: "/diagnosis/transaction/form-f-entry/list",
            permission: "formf.list"
          },
          {
            title: "Expense Entry (Diagnosis)",
            type: "link",
            path: "/diagnosis/transaction/expense-entry/list",
            permission: "expense.list"
          }
        ]
      },
      {
        title: "Reports",
        type: "sub",
        children: [
          {
            title: "Lab Registration Report",
            type: "link",
            path: "/diagnosis/report/lab-registration-report",
            permission: "labregistrationreport"
          },
          {
            title: "Area Wise Lab Registration Report",
            type: "link",
            path: "/diagnosis/report/area-wise-lab-registration-report",
            permission: "areawiselabregistrationreport"
          },
          {
            title: "Consultant Test Wise Lab Registration Report",
            type: "link",
            path:
              "/diagnosis/report/consultant-test-wise-lab-registration-report",
            permission: "consultanttestwiselabregistrationreport"
          },
          {
            title: "Patient Test Report",
            type: "link",
            path: "/diagnosis/report/patient-test-report",
            permission: "patienttestreport"
          },
          {
            title: "Lab Dues Report",
            type: "link",
            path: "/diagnosis/report/lab-dues-report",
            permission: "labduesreport"
          },
          {
            title: "Category Test Wise Register",
            type: "link",
            path: "/diagnosis/report/category-test-wise-register",
            permission: "categorytestwiseregister"
          },
          {
            title: "Category Wise Census Report",
            type: "link",
            path: "/diagnosis/report/category-wise-census-report",
            permission: "categorywisecensusreport"
          },
          {
            title: "Category Wise Lab Summary",
            type: "link",
            path: "/diagnosis/report/category-wise-lab-summary",
            permission: "categorywiselabsummary"
          },
          {
            title: "Sub Speciality Patient Statistical Report",
            type: "link",
            path: "/diagnosis/report/sub-speciality-patient-statistical-report",
            permission: "subspecialitypatientstatisticalreport"
          },
          {
            title: "Department Summary",
            type: "link",
            path: "/diagnosis/report/department-summary",
            permission: "departmentsummary"
          },
          {
            title: "Month Wise Summary",
            type: "link",
            path: "/diagnosis/report/month-wise-summary",
            permission: "monthwisesummary"
          },
          {
            title: "Category Wise Test Wise Report",
            type: "link",
            path: "/diagnosis/report/category-wise-test-wise-report",
            permission: "categorywisetestwisereport"
          },
          {
            title: "Worksheet Print",
            type: "link",
            path: "/diagnosis/report/worksheet-print",
            permission: "worksheetprint"
          },
          {
            title: "Form-F Report",
            type: "link",
            path: "/diagnosis/report/form-f-report",
            permission: "formfreport"
          },
          {
            title: "Lab Refund Report",
            type: "link",
            path: "/diagnosis/report/lab-refund-report",
            permission: "labrefundreport"
          },
          {
            title: "Lab Discount Report",
            type: "link",
            path: "/diagnosis/report/lab-discount-report",
            permission: "labdiscountreport"
          },
          {
            title: "Test Negative Report",
            type: "link",
            path: "/diagnosis/report/test-negative-report",
            permission: "testnegativereport"
          },
          {
            title: "Pending Test Report",
            type: "link",
            path: "/diagnosis/report/pending-test-report",
            permission: "pendingtestreport"
          },
          {
            title: "Lab Ledger Report",
            type: "link",
            path: "/diagnosis/report/lab-ledger-report",
            permission: "labledgerreport"
          }
        ]
      }
    ]
  },
  {
    title: "MIS",
    type: "sub",
    icon: Airplay,
    active: false,
    children: [
      {
        title: "Reports",
        type: "sub",
        children: [
          {
            title: "Collection Register",
            type: "link",
            path: "/mis/report/collection-register",
            permission: "collectionregister"
          },
          {
            title: "User Wise Collection Register",
            type: "link",
            path: "/mis/report/user-wise-collection-register",
            permission: "userwisecollectionregister"
          },
          {
            title: "Doctor Wise Collection Register",
            type: "link",
            path: "/mis/report/doctor-wise-collection-register",
            permission: "doctorwisecollectionregister"
          },
          {
            title: "Department OPD/IPD Report",
            type: "link",
            path: "/mis/report/department-opd-ipd-report",
            permission: "departmentopdipdreport"
          },
          {
            title: "Consultant Sharing Report",
            type: "link",
            path: "/mis/report/consultant-sharing-report",
            permission: "consultantsharingreport"
          },
          {
            title: "Birthday/Anniversary Report",
            type: "link",
            path: "/mis/report/birthday-anniversary-report",
            permission: "birthdayanniversaryreport"
          },
          {
            title: "User Wise Edit Report",
            type: "link",
            path: "/mis/report/user-wise-edit-report",
            permission: "userwiseeditreport"
          },
          {
            title: "User Wise Login Report",
            type: "link",
            path: "/mis/report/user-wise-login-report",
            permission: "userwiseloginreport"
          },
          {
            title: "Daily Activity Report",
            type: "link",
            path: "/mis/report/daily-activity-report",
            permission: "dailyactivityreport"
          },
          {
            title: "Patient History",
            type: "link",
            path: "/mis/report/patient-history",
            permission: "patienthistory"
          },
          {
            title: "User Cash Collection",
            type: "link",
            path: "/mis/report/user-cash-collection",
            permission: "usercashcollection"
          },
          {
            title: "Registration Details Report",
            type: "link",
            path: "/mis/report/registration-detail-report",
            permission: "registrationdetailsreport"
          },
          {
            title: "Yearly Collection Register",
            type: "link",
            path: "/mis/report/yearly-collection-register",
            permission: "yearlycollectionregister"
          },
          {
            title: "Net Revenue Report",
            type: "link",
            path: "/mis/report/net-revenue-report",
            permission: "netrevenuereport"
          },
          {
            title: "Date Wise Collection Report",
            type: "link",
            path: "/mis/report/date-wise-collection-report",
            permission: "datewisecollectionreport"
          },
          {
            title: "Refund Report",
            type: "link",
            path: "/mis/report/refund-report",
            permission: "refundreport"
          }
        ]
      },
      {
        title: "Expense",
        type: "sub",
        children: [
          {
            title: "Expense Entry",
            type: "link",
            path: "/mis/expense/expense-entry/list",
            permission: "expense.list"
          },
          {
            title: "Expense Report",
            type: "link",
            path: "/mis/expense/expense-report",
            permission: "expensereport"
          }
        ]
      }
    ]
  },
  {
    title: "Med. Store ",
    type: "sub",
    icon: Airplay,
    active: false,
    children: [
      {
        title: "Master",
        type: "sub",
        children: [
          {
            title: "Category Master",
            type: "link",
            path: "/medical-store/master/category/list",
            permission: "category.list"
          },
          {
            title: "Pharma Company Master",
            type: "link",
            path: "/medical-store/master/pharma-company/list",
            permission: "pharmacompany.list"
          },
          {
            title: "Medicine Composition Master",
            type: "link",
            path: "/medical-store/master/medicine-composition/list",
            permission: "medicinecomposition.list"
          },
          {
            title: "Medicine Group Master",
            type: "link",
            path: "/medical-store/master/medicine-group/list",
            permission: "medicinegroup.list"
          },
          {
            title: "Item Master",
            type: "link",
            path: "/medical-store/master/item/list",
            permission: "item.list"
          }
        ]
      },
      {
        title: "Transaction",
        type: "sub",
        children: [
          {
            title: "Purchase Bill Entry",
            type: "link",
            path: "/medical-store/transaction/purchase-bill-entry/list",
            permission: "purchasebill.list"
          },
          {
            title: "Purchase Bill Return Entry",
            type: "link",
            path: "/medical-store/transaction/purchase-bill-return-entry/list",
            permission: "purchasebillreturn.list"
          },
          {
            title: "Sale Bill Entry",
            type: "link",
            path: "/medical-store/transaction/sale-bill-entry/list",
            permission: "salebill.list"
          },
          {
            title: "Sale Bill Return Entry",
            type: "link",
            path: "/medical-store/transaction/sale-bill-return-entry/list",
            permission: "salebillreturn.list"
          },
          {
            title: "Issue/Receive Entry",
            type: "link",
            path: "/medical-store/transaction/issue-receive-entry/list",
            permission: "issuereceive.list"
          },
          {
            title: "Department Issue Entry",
            type: "link",
            path: "/medical-store/transaction/department-issue-entry/list",
            permission: "departmentissue.list"
          },
          {
            title: "Estimate Entry",
            type: "link",
            path: "/medical-store/transaction/estimate-entry/list",
            permission: "estimate.list"
          },
          {
            title: "Stock Transfer Entry",
            type: "link",
            path: "/medical-store/transaction/stock-transfer-entry/list",
            permission: "stocktransfer.list"
          }
        ]
      },
      {
        title: "Reports",
        type: "sub",
        children: [
          {
            title: "M.R.N Register",
            type: "link",
            path: "/medical-store/report/mrn-register",
            permission: "mrnregister"
          },
          {
            title: "Purchase Register",
            type: "link",
            path: "/medical-store/report/purchase-register",
            permission: "purchaseregister"
          },
          {
            title: "Purchase Summary",
            type: "link",
            path: "/medical-store/report/purchase-summary",
            permission: "purchasesummary"
          },
          {
            title: "Sale Register",
            type: "link",
            path: "/medical-store/report/sale-register",
            permission: "saleregister"
          },
          {
            title: "Sale Register Restricted",
            type: "link",
            path: "/medical-store/report/sale-register-restricted",
            permission: "saleregisterrestricted"
          },
          {
            title: "Sale Summary",
            type: "link",
            path: "/medical-store/report/sale-summary",
            permission: "salesummary"
          },
          {
            title: "Issue/Receive Register",
            type: "link",
            path: "/medical-store/report/issue-receive-register",
            permission: "issuereceiveregister"
          },
          {
            title: "Stock Transfer Register",
            type: "link",
            path: "/medical-store/report/stock-transfer-register",
            permission: "stocktransferregister"
          },
          {
            title: "Estimate Register",
            type: "link",
            path: "/medical-store/report/estimate-register",
            permission: "estimateregister"
          },
          {
            title: "Expiry Report",
            type: "link",
            path: "/medical-store/report/expiry-report",
            permission: "expiryreport"
          },
          {
            title: "IPD Medicine Issue Report",
            type: "link",
            path: "/medical-store/report/ipd-medicine-issue-report",
            permission: "ipdmedicineissuereport"
          },
          {
            title: "IPD Medicine Issue Summary",
            type: "link",
            path: "/medical-store/report/ipd-medicine-issue-summary",
            permission: "ipdmedicineissuesummary"
          },
          {
            title: "IPD Medicine Bills Reprint",
            type: "link",
            path: "/medical-store/report/ipd-medicine-bills-reprint",
            permission: "ipdmedicinebillsreprint"
          },
          {
            title: "Non Moving Medicine",
            type: "link",
            path: "/medical-store/report/non-moving-medicine",
            permission: "nonmovingmedicine"
          },
          {
            title: "Item Wise Profitability Report",
            type: "link",
            path: "/medical-store/report/item-wise-profitability-report",
            permission: "itemwiseprofitabilityreport"
          },
          {
            title: "Item Wise Purchase/Sale Report",
            type: "link",
            path: "/medical-store/report/item-wise-purchase-sale-report",
            permission: "itemwisepurchasesalereport"
          },
          {
            title: "Discharge Bill Report",
            type: "link",
            path: "/medical-store/report/discharge-bill-report",
            permission: "dischargebillreport"
          },
          {
            title: "Medical Activity Report",
            type: "link",
            path: "/medical-store/report/medical-activity-report",
            permission: "medicalactivityreport"
          },
          {
            title: "MIS Report",
            type: "link",
            path: "/medical-store/report/mis-report",
            permission: "misreport"
          },
          {
            title: "User Wise Collection Register",
            type: "link",
            path: "/medical-store/report/user-wise-collection-register",
            permission: "userwisecollectionregister"
          },
          {
            title: "User Wise Edit Report (Purchase)",
            type: "link",
            path: "/medical-store/report/user-wise-edit-report-purchase",
            permission: "userwiseeditreportpurchase"
          },
          {
            title: "User Wise Edit Report (Sale)",
            type: "link",
            path: "/medical-store/report/user-wise-edit-report-sale",
            permission: "userwiseeditreportsale"
          },
          {
            title: "Sale Audit Report",
            type: "link",
            path: "/medical-store/report/sale-audit-report",
            permission: "saleauditreport"
          },
          {
            title: "Department Issue Register",
            type: "link",
            path: "/medical-store/report/department-issue-register",
            permission: "departmentissueregister"
          }
        ]
      },
      {
        title: "Stock Reports",
        type: "sub",
        children: [
          {
            title: "Opening Stock Report",
            type: "link",
            path: "/medical-store/stock-report/opening-stock-report",
            permission: "openingstockreport"
          },
          {
            title: "Stock Ledger",
            type: "link",
            path: "/medical-store/stock-report/stock-ledger",
            permission: "stockledger"
          },
          {
            title: "Stock Summary",
            type: "link",
            path: "/medical-store/stock-report/stock-summary",
            permission: "stocksummary"
          },
          {
            title: "Stock Taking Sheet",
            type: "link",
            path: "/medical-store/stock-report/stock-taking-sheet",
            permission: "stocktakingsheet"
          },
          {
            title: "Stock Order Report (Min/Max)",
            type: "link",
            path: "/medical-store/stock-report/stock-order-report",
            permission: "stockorderreport"
          },
          {
            title: "Stock Valuation",
            type: "link",
            path: "/medical-store/stock-report/stock-valuation",
            permission: "stockvaluation"
          },
          {
            title: "Stock Report",
            type: "link",
            path: "/medical-store/stock-report/stock-report",
            permission: "stockreport"
          },
          {
            title: "Batch Wise Stock Summary",
            type: "link",
            path: "/medical-store/stock-report/batch-wise-stock-summary",
            permission: "batchwisestocksummary"
          },
          {
            title: "Department Wise Stock Summary",
            type: "link",
            path: "/medical-store/stock-report/department-wise-stock-summary",
            permission: "departmentwisestocksummary"
          }
        ]
      },
      {
        title: "Tax Reports",
        type: "sub",
        children: [
          {
            title: "Purchase GST Report (Annexure-A)",
            type: "link",
            path: "/medical-store/tax-report/purchase-gst-report",
            permission: "purchasegstreport"
          },
          {
            title: "Sale GST Report (Annexure-B)",
            type: "link",
            path: "/medical-store/tax-report/sale-gst-report",
            permission: "salegstreport"
          },
          {
            title: "GST In Tax Report",
            type: "link",
            path: "/medical-store/tax-report/gst-in-tax-report",
            permission: "gstintaxreport"
          },
          {
            title: "GST Out Tax Report",
            type: "link",
            path: "/medical-store/tax-report/gst-out-tax-report",
            permission: "gstouttaxreport"
          },
          {
            title: "GST Computation Report",
            type: "link",
            path: "/medical-store/tax-report/gst-computation-report",
            permission: "gstcomputationreport"
          }
        ]
      },
      {
        title: "Utility",
        type: "sub",
        children: [
          {
            title: "Environment Setting",
            type: "link",
            path: "/medical-store/utility/environment-setting",
            permission: "environmentsetting"
          },
          {
            title: "Profit Slab",
            type: "link",
            path: "/medical-store/utility/profit-slab",
            permission: "profitslab"
          },
          {
            title: "Stock Updation",
            type: "link",
            path: "/medical-store/utility/stock-updation",
            permission: "stockupdation"
          },
          {
            title: "Payment Receive Posting",
            type: "link",
            path: "/medical-store/utility/payment-receive-posting",
            permission: "paymentreceiveposting"
          }
        ]
      }
    ]
  },
  {
    title: "Accounts",
    type: "sub",
    icon: Airplay,
    active: false,
    children: [
      {
        title: "Transaction",
        type: "sub",
        children: [
          {
            title: "Voucher Entry",
            type: "link",
            path: "/accounts/transaction/voucher-entry/list",
            permission: "voucher.list"
          },
          {
            title: "Bank Reconciliation",
            type: "link",
            path: "/accounts/transaction/bank-reconciliation/list",
            permission: "bankreconciliation.list"
          },
          {
            title: "OPD/IPD/Diagnostics A/C Posting",
            type: "link",
            path: "/accounts/transaction/opd-ipd-diagnostics-acc-posting/list",
            permission: "opdipddiagnosticsaccountposting.list"
          }
        ]
      },
      {
        title: "Display",
        type: "sub",
        children: [
          {
            title: "Balance Sheet",
            type: "link",
            path: "/accounts/display/balance-sheet",
            permission: "balancesheet"
          },
          {
            title: "Profit And Loss Account",
            type: "link",
            path: "/accounts/display/profit-and-loss-account",
            permission: "profitandlossaccount"
          },
          {
            title: "Trial Balance (Group)",
            type: "link",
            path: "/accounts/display/trial-balance-group",
            permission: "trialbalancegroup"
          },
          {
            title: "Trial Balance (Ledger)",
            type: "link",
            path: "/accounts/display/trial-balance-ledger",
            permission: "trialbalanceledger"
          }
        ]
      },
      {
        title: "Reports",
        type: "sub",
        children: [
          {
            title: "Daily Book",
            type: "link",
            path: "/accounts/report/daily-book",
            permission: "dailybook"
          },
          {
            title: "Ledger",
            type: "link",
            path: "/accounts/report/ledger",
            permission: "ledger"
          },
          {
            title: "Interest Ledger",
            type: "link",
            path: "/accounts/report/interest-ledger",
            permission: "interestledger"
          },
          {
            title: "Cash Book",
            type: "link",
            path: "/accounts/report/cash-book",
            permission: "cashbook"
          },
          {
            title: "Cash Book (Consolidated)",
            type: "link",
            path: "/accounts/report/cash-book-consolidated",
            permission: "cashbookconsolidated"
          },
          {
            title: "Bank Book",
            type: "link",
            path: "/accounts/report/bank-book",
            permission: "bankbook"
          },
          {
            title: "Jurnal Book",
            type: "link",
            path: "/accounts/report/jurnal-book",
            permission: "jurnalbook"
          },
          {
            title: "Annexure",
            type: "link",
            path: "/accounts/report/annexure",
            permission: "annexure"
          },
          {
            title: "Bank Register",
            type: "link",
            path: "/accounts/report/bank-register",
            permission: "bankregister"
          },
          {
            title: "Ageing Analysis For Debtors",
            type: "link",
            path: "/accounts/report/ageing-analysis-for-debtors",
            permission: "ageinganalysisfordebtors"
          },
          {
            title: "Ageing Analysis For Creditors",
            type: "link",
            path: "/accounts/report/ageing-analysis-for-creditors",
            permission: "ageinganalysisforcreditors"
          },
          {
            title: "Cheque Cleared Register",
            type: "link",
            path: "/accounts/report/cheque-cleared-register",
            permission: "chequeclearedregister"
          },
          {
            title: "Cheque Not Cleared Register",
            type: "link",
            path: "/accounts/report/cheque-not-cleared-register",
            permission: "chequenotclearedregister"
          },
          {
            title: "Outstanding Report For Debtors",
            type: "link",
            path: "/accounts/report/outstanding-report-for-debtors",
            permission: "outstandingreportfordebtors"
          },
          {
            title: "Outstanding Report For Creditors",
            type: "link",
            path: "/accounts/report/outstanding-report-for-creditors",
            permission: "outstandingreportforcreditors"
          },
          {
            title: "Daily Transaction Summary",
            type: "link",
            path: "/accounts/report/daily-transaction-summary",
            permission: "dailytransactionsummary"
          },
          {
            title: "Detailed Trial Ledger",
            type: "link",
            path: "/accounts/report/detailed-trial-ledger",
            permission: "detailedtrialledger"
          },
          {
            title: "A/C Check List",
            type: "link",
            path: "/accounts/report/acc-check-list",
            permission: "accountchecklist"
          },
          {
            title: "Bill Wise Outstanding For Debtors",
            type: "link",
            path: "/accounts/report/bill-wise-outstanding-for-debtors",
            permission: "billwiseoutstandingfordebtors"
          },
          {
            title: "User Wise Edit Report",
            type: "link",
            path: "/accounts/report/user-wise-edit-report",
            permission: "userwiseeditreport"
          },
          {
            title: "Details Of Expenses/Revenues Month Wise",
            type: "link",
            path: "/accounts/report/details-of-expenses-revenues-month-wise",
            permission: "detailsofexpensesrevenuesmonthwise"
          }
        ]
      },
      {
        title: "Utility",
        type: "sub",
        children: [
          {
            title: "Parameter Setting",
            type: "link",
            path: "/accounts/utility/parameter-setting",
            permission: "parametersetting"
          },
          {
            title: "Opening Balance Transfer",
            type: "link",
            path: "/accounts/utility/opening-balance-transfer",
            permission: "openingbalancetransfer"
          }
        ]
      }
    ]
  },
  {
    title: "Utility",
    type: "sub",
    icon: Airplay,
    active: false,
    children: [
      {
        title: "System",
        type: "sub",
        children: [
          {
            title: "Company",
            type: "link",
            path: "/utility/company/list",
            permission: "company.list"
          },
          {
            title: "User Master",
            type: "link",
            path: "/utility/user/list",
            permission: "usermaster.list"
          },
          {
            title: "User Permission",
            type: "link",
            path: "/utility/user-permission",
            permission: "userpermission"
          },
          // {
          //   title: "User Lab Permission",
          //   type: "link",
          //   path: "/utility/user-lab-permission",
          //   permission: "userlabpermission"
          // },
          {
            title: "Copy User Permission",
            type: "link",
            path: "/utility/copy-user-permission",
            permission: "copyuserpermission"
          },
          {
            title: "Environment Setting",
            type: "link",
            path: "/utility/environment-setting",
            permission: "environmentsetting"
          },
          {
            title: "Database Backup",
            type: "link",
            path: "/utility/database-backup",
            permission: "databasebackup"
          },
          {
            title: "Bill Check Entry",
            type: "link",
            path: "/utility/bill-check-entry/list",
            permission: "billcheckentry.list"
          },
          {
            title: "Lab Bill Check Entry",
            type: "link",
            path: "/utility/lab-bill-check-entry/list",
            permission: "labbillcheckentry.list"
          },
          {
            title: "Define Voucher Type",
            type: "link",
            path: "/utility/define-voucher-type/list",
            permission: "definevoucher.list"
          },
          {
            title: "Open OPD Voucher Type",
            type: "link",
            path: "/utility/open-opd-voucher-type/list",
            permission: "openopdvoucher.list"
          },
          {
            title: "Financial Year Updation",
            type: "link",
            path: "/utility/financial-year/list",
            permission: "financialyear.list"
          },
          {
            title: "Database Split",
            type: "link",
            path: "/utility/database-split",
            permission: "databasesplit"
          }
        ]
      }
    ]
  },
  {
    title: "Messaging",
    type: "sub",
    icon: Airplay,
    active: false,
    children: [
      {
        title: "Inbox",
        type: "link",
        path: "/messaging/inbox",
        permission: "message.inbox"
      },
      {
        title: "Outbox",
        type: "link",
        path: "/messaging/outbox",
        permission: "message.outbox"
      },
      {
        title: "Password Change",
        type: "link",
        path: "/messaging/password-change",
        permission: "passwordchange"
      },
      {
        title: "Company Change",
        type: "link",
        path: "/messaging/company-change",
        permission: "companychange"
      }
    ]
  }
]; // Masters*********************************** // OPD*********************************** // ipd menus************************************* //Diagnosis menus*********************************** //MIS menus**************************************** //medical store menus************************************** // Accounts menus************************************* // Utility menus************************************* // Messaging menus*************************************
